/* eslint-disable no-param-reassign */
import {
  AccordionItemContentElement,
  AccordionItemElement,
  AccordionItemHeaderElement,
} from '@typedream/core';
import { getParentNode } from '@udecode/plate-core';
import { DreamWithOverride } from '../../plate';
import {
  ELEMENT_ACCORDION,
  ELEMENT_ACCORDION_ITEM,
  ELEMENT_ACCORDION_ITEM_CONTENT,
  ELEMENT_ACCORDION_ITEM_HEADER,
} from '../../pluginKeys';
import {
  normalizeAccordionItem,
  normalizeAccordionItemContent,
  normalizeAccordionItemHeader,
} from './normalizers/normalizeAccordionItem';
import { normalizeNonAccordionItemChild } from './normalizers/normalizeNonAccordionItemChild';

export const withAccordionItem: DreamWithOverride = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    if (
      node.type === ELEMENT_ACCORDION_ITEM
      && normalizeAccordionItem(editor, [node as AccordionItemElement, path])
    ) {
      return;
    }

    if (
      node.type === ELEMENT_ACCORDION_ITEM_HEADER
      && normalizeAccordionItemHeader(editor, [
        node as AccordionItemHeaderElement,
        path,
      ])
    ) {
      return;
    }

    if (
      node.type === ELEMENT_ACCORDION_ITEM_CONTENT
      && normalizeAccordionItemContent(editor, [
        node as AccordionItemContentElement,
        path,
      ])
    ) {
      return;
    }

    if (
      getParentNode(editor, path)?.[0]?.type === ELEMENT_ACCORDION
      && node.type !== ELEMENT_ACCORDION_ITEM
    ) {
      normalizeNonAccordionItemChild(editor, entry);
      return;
    }

    normalizeNode(entry);
  };

  return editor;
};
